import { render, staticRenderFns } from "./ObjectRefsView.vue?vue&type=template&id=6d9059da"
import script from "./ObjectRefsView.vue?vue&type=script&lang=js"
export * from "./ObjectRefsView.vue?vue&type=script&lang=js"
import style0 from "./ObjectRefsView.vue?vue&type=style&index=0&id=6d9059da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports